import React from 'react';
import CollectionFetch from "@web/ui/containers/CollectionFetch";
import DashboardFullRow from "./DashboardFullRow";
import LineAppTasks from "./LineAppTasks";

function TasksContent() {
  return <DashboardFullRow>
    <section style={{width: "100%", margin: "0 auto"}}>
      <CollectionFetch collectionId="tasks" component={LineAppTasks} />
    </section>
  </DashboardFullRow>
}

export default TasksContent;
